import React, { Component } from "react";
import "./App.css";
import fire from "./fire.js";

const db = fire.firestore();
class Team extends Component {
  state = {
    user: null,
    userdetails: null,
    emailpresent: null,
    grouppresentinemail: null,
    groupname: null,
    email: null,
    figure: null,
    data: null,
    membertwo: null,
    memberthree: null,
    minary: false,
  };
  componentDidMount = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({ userdetails: user });
        const { email } = user;
        this.setState({ emailpresent: email });
        this.setState({ user: true });
        const data = db.collection("groups").doc(email);
        data.get().then((doc) => {
          if (doc.exists) {
            this.setState({ minary: true });
            const deta = doc.data();
            const { grouppresentinemail } = deta;
            const { groupname } = deta;
            const { email } = deta;
            const { membertwo } = deta;
            const { memberthree } = deta;
            this.setState({ membertwo: membertwo });
            this.setState({ memberthree: memberthree });
            this.setState({ grouppresentinemail: grouppresentinemail });
            this.setState({ groupname: groupname });
            this.setState({ email: email });
          } else {
            this.setState({ minary: false });
            this.setState({ grouppresentinemail: false });
          }
        });
      } else {
        this.setState({ user: false });
      }
    });
  };
  render() {
    if (this.state.minary === true) {
      if (this.state.grouppresentinemail === true) {
        return (
          <Ready
            groupname={this.state.groupname}
            emailpresent={this.state.emailpresent}
            email={this.state.email}
            membertwo={this.state.membertwo}
            memberthree={this.state.memberthree}
          />
        );
      } else if (this.state.membertwo === this.state.emailpresent) {
        return (
          <Ready
            groupname={this.state.groupname}
            emailpresent={this.state.emailpresent}
            email={this.state.email}
            membertwo={this.state.membertwo}
            memberthree={this.state.memberthree}
          />
        );
      } else if (this.state.memberthree === this.state.emailpresent) {
        return (
          <Ready
            groupname={this.state.groupname}
            emailpresent={this.state.emailpresent}
            email={this.state.email}
            membertwo={this.state.membertwo}
            memberthree={this.state.memberthree}
          />
        );
      }
    } else if (this.state.minary === false) {
      if (this.state.user === false && this.state.emailpresent !== null) {
        return <Choose />;
      } else if (
        this.state.user === true &&
        this.state.grouppresentinemail === false
      ) {
        return <Main email={this.state.emailpresent} />;
      }
    }
    return (
      <div id="load">
        <div>G</div>
        <div>N</div>
        <div>I</div>
        <div>D</div>
        <div>A</div>
        <div>O</div>
        <div>L</div>
      </div>
    );
  }
}
export default Team;

class Ready extends Component {
  state = {
    key: "",
    styleing: "membergroup",
    dkey: "",
    mergeerr: "",
    deletion: "",
    desc: null,
    email: null,
    groupname: null,
    grouppresentinemail: null,
    idea: null,
    memberthree: null,
    membertwo: null,
    totalmembers: null,
    major: "",
  };
  componentDidMount = () => {
    const data = db.collection("groups").doc(this.props.emailpresent);
    data.get().then((doc) => {
      if (doc.exists) {
        const deta = doc.data();
        const { desc } = deta;
        const { email } = deta;
        const { groupname } = deta;
        const { grouppresentinemail } = deta;
        const { idea } = deta;
        const { memberthree } = deta;
        const { membertwo } = deta;
        const { totalmembers } = deta;
        this.setState({ desc: desc });
        this.setState({ email: email });
        this.setState({ groupname: groupname });
        this.setState({ grouppresentinemail: grouppresentinemail });
        this.setState({ idea: idea });
        this.setState({ memberthree: memberthree });
        this.setState({ membertwo: membertwo });
        this.setState({ totalmembers: totalmembers });
        if (email === this.props.emailpresent) {
          this.setState({ key: "Leader" });
          this.setState({ styleing: "leader" });
          this.setState({ dkey: "Delete Group" });
        } else {
          this.setState({ key: "Member" });
          this.setState({ dkey: "Exit Group" });
          this.setState({ styleing: "membermember" });
        }
      } else {
        return;
      }
    });
  };
  submit = () => {
    this.setState({ deletion: "Deleting..." });
    if (this.state.email === this.state.emailpresent) {
      const data = {
        desc: this.state.desc,
      };
      db.collection("groups")
        .doc(this.state.email)
        .set(data)
        .then(() => {
          window.location.reload(false);
        });
    } else if (this.state.membertwo === this.props.emailpresent) {
      const data = {
        desc: this.state.desc,
        email: this.state.email,
        groupname: this.state.groupname,
        grouppresentinemail: this.state.grouppresentinemail,
        idea: this.state.idea,
        memberthree: this.state.memberthree,
        membertwo: null,
        totalmembers: this.state.totalmembers - 1,
      };
      db.collection("groups")
        .doc(this.state.email)
        .set(data)
        .then(() => {
          window.location.reload(false);
        });
    } else if (this.state.memberthree === this.props.emailpresent) {
      const data = {
        desc: this.state.desc,
        email: this.state.email,
        groupname: this.state.groupname,
        grouppresentinemail: this.state.grouppresentinemail,
        idea: this.state.idea,
        memberthree: null,
        membertwo: this.state.membertwo,
        totalmembers: this.state.totalmembers - 1,
      };
      db.collection("groups")
        .doc(this.state.email)
        .set(data)
        .then(() => {
          window.location.reload(false);
        });
    }
    db.collection("groups")
      .doc(this.props.emailpresent)
      .delete()
      .then(function () {
        window.location.reload(false);
      });
  };
  chatgroup = () => {
    new Notification("Hey From Bezlin");
    if (!("Notification" in window)) {
      alert("This browser does not support desktop notification");
    } else {
      Notification.requestPermission();
    }
    this.setState({ major: "Chat will be available soon ..." });
  };
  render() {
    return (
      <div className="R-divmain">
        <h1 className="white">{this.state.deletion}</h1>
        <h1 className="whiters">{this.state.mergeerr}</h1>
        <h1 className={this.state.styleing}>
          You are the {this.state.key} of Group - {this.props.groupname}
        </h1>
        <button onClick={this.submit} className="exitordeletebutton">
          {this.state.dkey}
        </button>
        <button onClick={this.chatgroup} className="groupteamchat">
          Group Chat
        </button>
        <a href="https://meet.google.com">
          <button className="groupteammeet">Instant Meeting</button>
        </a>
        <h2 className="red">{this.state.major}</h2>
        <h2 className="changestyle">Members in this Group</h2>
        <div className="whitishshades">
          {this.props.email !== null ? (
            <Qwerty client={this.props.email} />
          ) : (
            console.log()
          )}
          {this.props.membertwo !== null ? (
            <Qwertys client={this.props.membertwo} />
          ) : (
            console.log()
          )}

          {this.props.memberthree !== null ? (
            <Qwerty client={this.props.memberthree} />
          ) : (
            console.log()
          )}
        </div>
      </div>
    );
  }
}

class Choose extends Component {
  state = {};
  render() {
    return (
      <div className="form">
        <h1 className="loginheading">Login/Signup</h1>
        <a href="/login">
          <button className="loginbtnn">Log In</button>
        </a>
        <br />
        <a href="/signup">
          <button className="loginbtnn">Sign Up</button>
        </a>
      </div>
    );
  }
}
class Main extends Component {
  state = {
    tree: null,
  };
  start = () => {
    this.setState({ tree: true });
  };
  join = () => {
    this.setState({ tree: false });
  };
  render() {
    return (
      <div className="s-main">
        <div className="divbtndfghjk">
          <button className="joingroup" onClick={this.join}>
            Join Group
          </button>
          <button onClick={this.start} className="joingroup">
            Start Group
          </button>
        </div>
        {this.state.tree === true ? (
          <Start email={this.props.email} />
        ) : this.state.tree === false ? (
          <Join email={this.props.email} />
        ) : (
          console.log()
        )}
      </div>
    );
  }
}
class Join extends Component {
  state = {
    data: null,
  };
  componentDidMount = () => {
    db.collection("groups")
      .get()
      .then((querySnapshot) => {
        const data = querySnapshot.docs.map((doc) => doc.data());
        this.setState({ data: data });
      });
  };
  render() {
    return (
      <div className="joindivmain">
        <h1 className="white">
          Join a Team which you think is perfect for you.
        </h1>
        {this.state.data === null
          ? console.log()
          : this.state.data.map(function (self, key) {
              return (
                <div>
                  <li className="overlay" key={key}>
                    <Joinbox
                      desc={self.desc}
                      topic={self.idea}
                      name={self.groupname}
                      totalmembers={self.totalmembers}
                      membertwo={self.membertwo}
                      memberthree={self.memberthree}
                      email={self.email}
                    />
                  </li>
                </div>
              );
            })}
      </div>
    );
  }
}

class Joinbox extends Component {
  state = {
    chage: "",
    limit: "",
    emailpresent: null,
    desc: null,
    email: null,
    groupname: null,
    grouppresentinemail: null,
    idea: null,
    memberthree: null,
    membertwo: null,
    totalmembers: null,
    url1: null,
    url2: null,
    url3: null,
    name1: null,
    name2: null,
    name3: null,
    tree: null,
  };
  componentDidMount = () => {
    this.ultimatecomponent();
    if (this.props.totalmembers >= 3) {
      this.setState({ chage: "redchanger" });
    } else {
      this.setState({ chage: "Jboxdivmain" });
    }
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        const { email } = user;
        this.setState({ emailpresent: email });
        const data = db.collection("groups").doc(this.props.email);
        data.get().then((doc) => {
          if (doc.exists) {
            this.setState({ tree: true });
            const deta = doc.data();
            const { desc } = deta;
            const { email } = deta;
            const { groupname } = deta;
            const { grouppresentinemail } = deta;
            const { idea } = deta;
            const { memberthree } = deta;
            const { membertwo } = deta;
            const { totalmembers } = deta;
            this.setState({ desc: desc });
            this.setState({ email: email });
            this.setState({ groupname: groupname });
            this.setState({ grouppresentinemail: grouppresentinemail });
            this.setState({ idea: idea });
            this.setState({ memberthree: memberthree });
            this.setState({ membertwo: membertwo });
            this.setState({ totalmembers: totalmembers });
          } else {
            return;
          }
        });
      } else {
        this.setState({ user: false });
      }
    });
  };
  ultimatecomponent = () => {};
  ultimatejoin = () => {
    if (this.props.totalmembers >= 3) {
      this.setState({ limit: "This group is already full." });
    } else {
      if (this.props.membertwo === null) {
        this.setState({ limit: "Joining..." });
        const data = {
          desc: this.state.desc,
          email: this.state.email,
          groupname: this.state.groupname,
          grouppresentinemail: this.state.grouppresentinemail,
          idea: this.state.idea,
          memberthree: this.state.memberthree,
          membertwo: this.state.emailpresent,
          totalmembers: this.state.totalmembers + 1,
        };
        db.collection("groups")
          .doc(this.state.email)
          .set(data)
          .then(() => {
            window.location.reload(false);
          });
        const dark = {
          desc: this.state.desc,
          email: this.state.email,
          groupname: this.state.groupname,
          grouppresentinemail: this.state.grouppresentinemail,
          idea: this.state.idea,
          memberthree: this.state.memberthree,
          membertwo: this.state.emailpresent,
          totalmembers: this.state.totalmembers + 1,
        };
        db.collection("groups")
          .doc(this.state.emailpresent)
          .set(dark)
          .then(() => {
            window.location.reload(false);
          });
      } else if (this.state.memberthree === null) {
        this.setState({ limit: "Joining..." });
        const data = {
          desc: this.state.desc,
          email: this.state.email,
          groupname: this.state.groupname,
          grouppresentinemail: this.state.grouppresentinemail,
          idea: this.state.idea,
          memberthree: this.state.emailpresent,
          membertwo: this.state.membertwo,
          totalmembers: this.state.totalmembers + 1,
        };
        db.collection("groups")
          .doc(this.state.email)
          .set(data)
          .then(() => {
            window.location.reload(false);
          });
        const dark = {
          desc: this.state.desc,
          email: this.state.email,
          groupname: this.state.groupname,
          grouppresentinemail: this.state.grouppresentinemail,
          idea: this.state.idea,
          memberthree: this.state.memberthree,
          membertwo: this.state.emailpresent,
          totalmembers: this.state.totalmembers + 1,
        };
        db.collection("groups")
          .doc(this.state.emailpresent)
          .set(dark)
          .then(() => {
            window.location.reload(false);
          });
      } else {
        return;
      }
    }
  };
  render() {
    return (
      <div className={this.state.chage}>
        <h2 className="couriervenonethonane">{this.props.name}</h2>
        <h3 className="asdfghj">Topic:-{this.props.topic}</h3>
        <h3 className="qwerty">Description</h3>
        <h4 className="zxcvbnm">{this.props.desc}</h4>
        <h1 className="tyhbvft">Total Members: {this.props.totalmembers}</h1>
        {this.state.email !== null ? (
          <Qwerty client={this.state.email} />
        ) : (
          console.log()
        )}
        {this.state.membertwo !== null ? (
          <Qwertys client={this.state.membertwo} />
        ) : (
          console.log()
        )}
        {this.state.memberthree !== null ? (
          <Qwerty client={this.state.memberthree} />
        ) : (
          console.log()
        )}
        <br />
        <button onClick={this.ultimatejoin} className="joingroupbtn">
          JOIN
        </button>
        <h3>{this.state.limit}</h3>
      </div>
    );
  }
}
class Qwerty extends Component {
  state = {
    url: null,
    name: null,
  };
  componentDidMount = () => {
    const data = db.collection("store").doc(this.props.client);
    data.get().then((doc) => {
      const deta = doc.data();
      const { url } = deta;
      const { name } = deta;
      this.setState({ name: name });
      this.setState({ url: url });
    });
  };
  render() {
    return (
      <div>
        <img className="qwertyurl" src={this.state.url} />
        <h1 className="qwertyname" id="sameline">
          {this.state.name}
        </h1>
      </div>
    );
  }
}
class Qwertys extends Component {
  state = {
    url: null,
    name: null,
  };
  componentDidMount = () => {
    const data = db.collection("store").doc(this.props.client);
    data.get().then((doc) => {
      const deta = doc.data();
      const { url } = deta;
      const { name } = deta;
      this.setState({ name: name });
      this.setState({ url: url });
    });
  };
  render() {
    return (
      <div>
        <h1 className="qwertyname" id="sameline">
          {this.state.name}
        </h1>
        <img className="qwertyurl" src={this.state.url} />
      </div>
    );
  }
}
class Start extends Component {
  state = {
    tree: true,
    mergeerr: "",
  };
  submit = () => {
    this.setState({ tree: true });
    const groupname = document.getElementById("groupname").value;
    const idea = document.getElementById("idea").value;
    const desc = document.getElementById("desc").value;
    if (groupname.length !== "" && idea !== "" && desc !== "") {
      this.setState({ mergeerr: "Submitting..." });
      const data = {
        email: this.props.email,
        groupname: groupname,
        idea: idea,
        desc: desc,
        grouppresentinemail: true,
        totalmembers: 1,
        membertwo: null,
        memberthree: null,
      };
      db.collection("groups")
        .doc(this.props.email)
        .set(data)
        .then(() => {
          window.location.reload(false);
        });
    } else {
      this.setState({ mergeerr: "These fields are required." });
    }
  };
  render() {
    return (
      <div className="start-main-div">
        <h1 className="startgroupheadingstyling">Start Group</h1>
        <input
          id="groupname"
          className="nameofthegroup"
          placeholder="Pick a name for your group."
        />
        <input
          id="idea"
          className="nameofthegroup"
          placeholder="What are you planing to make?"
        />
        <textarea
          id="desc"
          name="note"
          className="nameofthegroup"
          placeholder="Add group description."
        ></textarea>
        <br />
        <button onClick={this.submit} className="startgroupdone">
          Submit
        </button>
        <h1>{this.state.mergeerr}</h1>
      </div>
    );
  }
}
